import { Component, Input } from '@angular/core';


@Component({
  selector: 'ui-alert',
  standalone: true,
  imports: [],
  templateUrl: './ui-alert.component.html',
  styleUrl: './ui-alert.component.scss'
})
export class UiAlertComponent {
  @Input() variant: 'info' | 'success' | 'warning' | 'error' | 'neutral' = 'info';
  @Input() className = '';

  get computedClasses(): string {
    const classes = ['alert'];

    // DaisyUI variants
    const variantClassMap: Record<UiAlertComponent['variant'], string> = {
      info: 'alert-info',
      success: 'alert-success',
      warning: 'alert-warning',
      error: 'alert-error',
      neutral: 'alert-neutral',
    };
    classes.push(variantClassMap[this.variant]);

    if (this.className) {
      classes.push(this.className);
    }

    return classes.join(' ');
  }
}

